{
 "about_us": "About us",
 "ads_badge": "Ad",
 "allow": "Allow",
 "allow_notifications": "Allow notifications",
 "allow_notifications_message": "To stay up to date with the latest news. You can change this at any time in Settings.",
 "allow_notifications_title": "Allow Notifications",
 "article": "Article",
 "button_share": "Share",
 "cancel": "Cancel",
 "catalog_tab_club_tournaments": "Club tournaments",
 "catalog_tab_federations": "Federations",
 "catalog_tab_teams": "Teams",
 "delete": "Delete",
 "delete_account": "Delete Account",
 "delimiter_login_text": "Or sign in with",
 "dismiss": "Dismiss",
 "email_address": "Email Address",
 "enter_your_email": "Enter Your Email",
 "enter_your_password": "Enter Your Password",
 "entry_successful": "Entry successful",
 "error": "Error",
 "favorite_updates": "Favorite updates",
 "forgotten_password": "Forgotten your password?",
 "fw_battle_big_boss": "Big boss",
 "fw_battle_boss": "Boss",
 "fw_battle_boss_failed": "The boss held — gather gold and challenge again",
 "fw_battle_challenge": "Challenge the boss",
 "fw_battle_hint": "Tap the wicket to bowl",
 "fw_battle_legend": "Legend",
 "fw_battle_level": "Level {0}",
 "fw_battle_map": "Level map",
 "fw_battle_offline": "Your team kept breaking wickets for {0} min",
 "fw_battle_offline_items": "Your team also found {0} item(s) — they are in the loot bag.",
 "fw_battle_offline_ok": "Great",
 "fw_battle_offline_title": "While you were away",
 "fw_battle_wicket": "Wicket {0} of {1}",
 "fw_bmap_best": "Best: level {0}",
 "fw_bmap_fog": "The fog will lift as you go further",
 "fw_bmap_here": "You are here",
 "fw_bonus_points": "+{0} rating points",
 "fw_bprof_best": "Best level",
 "fw_bprof_bosses": "Bosses beaten",
 "fw_bprof_captain": "Captain level",
 "fw_bprof_counters": "Records",
 "fw_bprof_cups": "Cups",
 "fw_bprof_dps": "Team damage per second",
 "fw_bprof_hired": "Players in the team",
 "fw_bprof_m_cups": "Season cups",
 "fw_bprof_m_gear": "Gear",
 "fw_bprof_m_guild": "Club",
 "fw_bprof_m_in_form": "In form",
 "fw_bprof_m_rarity": "Rarity",
 "fw_bprof_m_relics": "Relics",
 "fw_bprof_m_stars": "Stars",
 "fw_bprof_m_team": "Team bonus",
 "fw_bprof_multipliers": "Multipliers",
 "fw_bprof_record": "Record level",
 "fw_bprof_season": "Season",
 "fw_bprof_tap": "Tap damage",
 "fw_bprof_wickets": "Wickets broken",
 "fw_chest_cheered": "📣 cheered",
 "fw_chest_correct": "{0}/{1} correct",
 "fw_chest_overs": "Overs guessed: {0}",
 "fw_chests_more": "+{0} more",
 "fw_claimed": "Claimed",
 "fw_community_joined": "You’re in the stands",
 "fw_community_members": "In the chat: {0}",
 "fw_community_my_club": "My club’s room",
 "fw_community_my_nation": "My country’s room",
 "fw_community_open": "Open {0} in Telegram",
 "fw_expires": "Until {0}",
 "fw_gold": "Gold",
 "fw_load_failed": "Couldn’t open the game. Check your connection and try again",
 "fw_reward_title": "Reward!",
 "fw_skill_err_active": "The skill is still active",
 "fw_skill_err_cooldown": "The skill is still recharging",
 "fw_skill_err_locked": "Level up the captain to unlock this skill",
 "fw_skill_locked": "Lv {0}",
 "fw_skills_close": "Close skills",
 "fw_soon_text": "This part of the game is coming to the app soon",
 "fw_splash_loading": "Preparing the arena…",
 "fw_team_capped": "Max level",
 "fw_team_card_wait": "Hire in turn",
 "fw_team_err_capped": "Rarity level cap reached",
 "fw_team_err_gold": "Not enough gold",
 "fw_team_err_locked": "Hire the previous player first",
 "fw_team_hire": "Hire",
 "fw_team_level": "Lv {0}",
 "fw_team_max": "Max",
 "fw_team_milestone": "Milestone at Lv {0}",
 "fw_team_next": "Next player",
 "fw_team_total": "Team: {0}/s",
 "fw_team_upgrade": "Upgrade",
 "fw_title": "Fantasy",
 "fw_world_err_generic": "Something went wrong. Please try again",
 "fw_world_err_unavailable": "Not available right now",
 "fw_world_exit": "Back to cricket",
 "go_to_settings": "Go to Settings",
 "hide_password": "Hide password",
 "invalid_email": "Invalid email address",
 "log_in": "Log in",
 "log_out": "Log Out",
 "login_error": "Login error",
 "mc_achievements": "Achievements",
 "mc_age": "Age",
 "mc_ai_summary": "AI summary",
 "mc_all": "All",
 "mc_all_innings": "All innings",
 "mc_archive_label": "Archive",
 "mc_article_unavailable": "This article is no longer available",
 "mc_avg_score": "Avg score",
 "mc_ax_collapsed": "Collapsed",
 "mc_ax_expanded": "Expanded",
 "mc_axis_average": "Average",
 "mc_axis_boundary_percent": "Boundary %",
 "mc_axis_sixes_per_100": "Sixes per 100",
 "mc_axis_strike_rate": "Strike rate",
 "mc_axis_survival": "Survival",
 "mc_ball_a11y": "Over {0}. {1} to {2}",
 "mc_ball_updated_at": "Updated {0}",
 "mc_balls": "Balls",
 "mc_batter_short": "Batter",
 "mc_batting": "Batting",
 "mc_batting_first_win_percent": "Batting first win %",
 "mc_batting_first_wins": "Batting first wins",
 "mc_best_chase": "Best chase",
 "mc_between_seasons": "Between seasons",
 "mc_boundaries": "Boundaries",
 "mc_bowler_note": "Bowling to the current batters",
 "mc_bowler_short": "Bowler",
 "mc_bowling": "Bowling",
 "mc_by_venues": "By venue",
 "mc_calendar": "Calendar",
 "mc_calibrated_on": "Calibrated on {0} matches",
 "mc_cancel": "Cancel",
 "mc_capacity": "Capacity",
 "mc_career": "Career",
 "mc_career_by_format": "Career by format",
 "mc_career_scope_note": "Stats cover matches in our coverage",
 "mc_champion": "Champion",
 "mc_chase_need": "Need {0} off {1} balls",
 "mc_chase_rain_revised": "Target revised by DLS (rain)",
 "mc_chase_target": "Target",
 "mc_chase_wickets_in_hand": "{0} wickets in hand",
 "mc_chasing_wins": "Chasing wins",
 "mc_close": "Close",
 "mc_col_format": "Format",
 "mc_compare": "Compare",
 "mc_compare_missing": "No data for the chosen player",
 "mc_compare_pick": "Compare with…",
 "mc_compare_remove": "Remove from comparison",
 "mc_context_facts_title": "In context",
 "mc_countdown_day": "1 day",
 "mc_countdown_days": "{0} days",
 "mc_current_bowler": "Current bowler",
 "mc_current_over": "Current over",
 "mc_did_not_bat": "Did not bat",
 "mc_domestic": "Domestic",
 "mc_dots": "Dots",
 "mc_drawn": "Drawn",
 "mc_duels": "Batter vs bowler",
 "mc_economy": "Economy",
 "mc_elected_bat": "elected to bat",
 "mc_elected_bowl": "elected to bowl",
 "mc_empty_commentary": "No balls bowled yet",
 "mc_empty_day": "No matches on this day",
 "mc_empty_graphs": "Graphs will appear once play begins",
 "mc_empty_scorecard": "Scorecard is not available yet",
 "mc_empty_squads": "Squads are not announced yet",
 "mc_error_title": "Something went wrong",
 "mc_extras": "Extras",
 "mc_fall_of_wickets": "Fall of wickets",
 "mc_fav_add": "Add to favourites",
 "mc_fav_limit_leagues": "You can follow up to {0} leagues",
 "mc_fav_limit_matches": "You can follow up to {0} matches",
 "mc_fav_limit_players": "You can follow up to {0} players",
 "mc_fav_limit_teams": "You can follow up to {0} teams",
 "mc_fav_not_added": "{0} favourites couldn’t be added — the limit is reached",
 "mc_fav_recommendations": "Recommendations",
 "mc_fav_remove": "Remove from favourites",
 "mc_favorites": "Favourites",
 "mc_favorites_empty": "Tap the star on a team, league, player or match",
 "mc_fielding": "Fielding",
 "mc_first_innings_avg": "Avg 1st-innings total",
 "mc_follow_on": "Follow-on",
 "mc_form": "Form",
 "mc_form_last_innings": "Last {0} innings",
 "mc_fours": "Fours",
 "mc_full_career_note": "Full career (data provider)",
 "mc_hand_left": "Left Hand",
 "mc_hand_right": "Right Hand",
 "mc_highest_total": "Highest total",
 "mc_home_my_matches": "My matches",
 "mc_impact_title": "Match impact",
 "mc_innings_shape": "Innings shape",
 "mc_international": "International",
 "mc_key_stats": "Key stats",
 "mc_last_overs": "Last {0} overs",
 "mc_leaders": "Leaders",
 "mc_leagues": "Leagues",
 "mc_ledger_incomplete": "The data provider did not save every ball of this match, so the feed is shorter than the score",
 "mc_live": "LIVE",
 "mc_live_activity_follow": "Show score on Lock Screen",
 "mc_live_activity_stop": "Stop showing score on Lock Screen",
 "mc_live_now": "Live now",
 "mc_load_more": "Load more",
 "mc_loading": "Loading",
 "mc_login_conflict": "This account is linked to another sign-in method",
 "mc_login_failed": "Sign-in failed — please try again",
 "mc_login_too_many": "Too many attempts — please try again later",
 "mc_lost": "Lost",
 "mc_lowest_total": "Lowest total",
 "mc_maiden": "Maiden",
 "mc_man_of_match": "Player of the match",
 "mc_match_numbers": "In numbers",
 "mc_matches": "Matches",
 "mc_milestone_left": "{0} to go",
 "mc_milestones": "Milestones",
 "mc_more_about_this": "More about this",
 "mc_new_balls": "New balls",
 "mc_news": "News",
 "mc_news_empty": "No news here yet",
 "mc_news_for_me": "For me",
 "mc_next_match": "Next match",
 "mc_no_data_yet": "No data yet",
 "mc_no_live_matches": "No live matches right now",
 "mc_no_result": "No result",
 "mc_numbers_title": "Team numbers",
 "mc_of": "of {0}",
 "mc_officials": "Officials",
 "mc_offline": "No internet connection",
 "mc_offline_check": "Please check your connection and try again",
 "mc_offline_live_note": "Live updates paused",
 "mc_on_strike": "On strike",
 "mc_onb_continue": "Continue",
 "mc_onb_fav_subtitle": "Tournaments, federations and teams — their matches and news come first",
 "mc_onb_fav_title": "Pick your favourites",
 "mc_onb_login": "Log in",
 "mc_onb_policy_accept": "Accept and continue",
 "mc_onb_policy_link": "Privacy Policy",
 "mc_onb_policy_message": "How the app uses data to make cricket yours",
 "mc_onb_policy_p1_body": "Your choices stay on your device and in your profile — nothing is sold",
 "mc_onb_policy_p1_title": "Privacy",
 "mc_onb_policy_p2_body": "Favourites put your teams’ matches and news first",
 "mc_onb_policy_p2_title": "Personalization",
 "mc_onb_policy_p3_body": "Change or clear your picks anytime in Favourites and Settings",
 "mc_onb_policy_p3_title": "Control",
 "mc_onb_policy_title": "Your data, your rules",
 "mc_onb_results": "Results",
 "mc_onb_signup": "Sign up",
 "mc_onb_skip": "Skip",
 "mc_onb_start": "Get started",
 "mc_onb_welcome_subtitle": "Matches, tournaments and news — follow what matters to you",
 "mc_onb_welcome_title": "All of cricket in one app",
 "mc_over_by_over": "Runs per over",
 "mc_over_number": "Over {0}",
 "mc_overs": "Overs",
 "mc_overs_played": "Overs played",
 "mc_partnership_current": "Current partnership",
 "mc_partnership_note": "The two batters on the field",
 "mc_partnerships": "Partnerships",
 "mc_phases": "Phases",
 "mc_played": "Played",
 "mc_playing_xi": "Playing XI",
 "mc_playoffs": "Road to the final",
 "mc_popular_leagues": "Popular leagues",
 "mc_popular_teams": "Popular teams",
 "mc_preview_title": "Preview",
 "mc_projected_score": "Projected score",
 "mc_projection_note": "Our estimate at the current run rate, not a forecast",
 "mc_qual_balls_bowled": "Min. {0} balls bowled",
 "mc_qual_balls_faced": "Min. {0} balls faced",
 "mc_qualification": "Qualification",
 "mc_radar_note": "Percentile among {0} players ({1})",
 "mc_radar_title": "Player profile",
 "mc_rating": "Rating",
 "mc_read_at_source": "Read at the source",
 "mc_rec_highest_chase": "Highest chase",
 "mc_rec_win_runs": "Biggest win (runs)",
 "mc_rec_win_wickets": "Biggest win (wickets)",
 "mc_recent_matches": "Recent matches",
 "mc_records": "Records",
 "mc_referee": "Referee",
 "mc_retry": "Retry",
 "mc_revised_target": "Revised target (DLS)",
 "mc_run_rate_by_over": "Run rate by over",
 "mc_runs": "Runs",
 "mc_search": "Search",
 "mc_search_hint": "Teams, leagues, players",
 "mc_search_leagues": "Leagues",
 "mc_search_no_results": "Nothing found",
 "mc_search_players": "Players",
 "mc_search_recent": "Recent",
 "mc_search_start_typing": "Type at least two characters to search",
 "mc_search_team_matches": "{0} matches",
 "mc_search_teams": "Teams",
 "mc_season": "Season",
 "mc_season_placings": "Season leaderboards",
 "mc_season_squad": "Season squad",
 "mc_session_expired": "Your session expired — please sign in again",
 "mc_share_match": "Share match card",
 "mc_share_player": "Share player card",
 "mc_show_all": "Show all",
 "mc_show_next_match_day": "Show next match day",
 "mc_sign_in_with_apple": "Sign in with Apple",
 "mc_sixes": "Sixes",
 "mc_split_away": "Away",
 "mc_split_batting_first": "Batting first",
 "mc_split_chasing": "Chasing",
 "mc_split_home": "Home",
 "mc_splits_min_balls": "Buckets under {0} balls are not shown",
 "mc_splits_title": "Splits",
 "mc_splits_unclassified": "{0} balls are in no bucket: the provider did not name the style",
 "mc_squad": "Squad",
 "mc_squad_size": "{0} in squad",
 "mc_standings": "Standings",
 "mc_stat_average": "Best average",
 "mc_stat_best_bowling": "Best bowling",
 "mc_stat_catches": "Most catches",
 "mc_stat_economy": "Best economy",
 "mc_stat_fours": "Most fours",
 "mc_stat_highest_score": "Highest score",
 "mc_stat_runs": "Most runs",
 "mc_stat_sixes": "Most sixes",
 "mc_stat_strike_rate": "Best strike rate",
 "mc_stat_wickets": "Most wickets",
 "mc_substitutes": "Substitutes",
 "mc_summary_title": "Match summary",
 "mc_super_over": "Super Over",
 "mc_tab_analysis": "Graphs",
 "mc_tab_commentary": "Commentary",
 "mc_tab_fixtures": "Fixtures",
 "mc_tab_h2h": "Head-to-head",
 "mc_tab_info": "Info",
 "mc_tab_overview": "Overview",
 "mc_tab_results": "Results",
 "mc_tab_scorecard": "Scorecard",
 "mc_tab_squads": "Squads",
 "mc_tab_stats": "Stats",
 "mc_tab_teams": "Teams",
 "mc_team_ranking": "Team rankings",
 "mc_this_match": "This match",
 "mc_this_over": "This over",
 "mc_today": "Today",
 "mc_tomorrow": "Tomorrow",
 "mc_top_batter": "Top batter",
 "mc_top_bowler": "Top bowler",
 "mc_top_players": "Top players",
 "mc_toss": "Toss",
 "mc_turning_points": "Turning points",
 "mc_tv_umpire": "TV umpire",
 "mc_umpires": "Umpires",
 "mc_upcoming_matches": "Upcoming matches",
 "mc_venue": "Venue",
 "mc_venue_conditions": "How it plays",
 "mc_video_consent_allow": "Allow",
 "mc_video_consent_later": "Not now",
 "mc_video_consent_privacy": "Google Privacy Policy",
 "mc_video_consent_terms": "YouTube Terms of Service",
 "mc_video_consent_text": "Videos play in the official YouTube player. Loading it sends data to YouTube and Google under their terms and privacy policy.",
 "mc_video_consent_title": "Videos from YouTube",
 "mc_video_open_youtube": "Open in YouTube",
 "mc_video_type_extended_highlights": "Extended highlights",
 "mc_video_type_highlights": "Highlights",
 "mc_video_type_wickets": "Wickets",
 "mc_video_unavailable": "This video is unavailable",
 "mc_videos": "Videos",
 "mc_videos_empty": "No videos yet",
 "mc_vs_average": "vs average",
 "mc_vs_teams": "Versus teams",
 "mc_wicket": "Wicket",
 "mc_wickets": "Wickets",
 "mc_win_chance": "Win chance",
 "mc_win_chance_curve": "Win chance by over",
 "mc_win_percent": "Win %",
 "mc_women": "Women",
 "mc_won": "Won",
 "mc_worm": "Score progression",
 "mc_years_old": "{0} y.o.",
 "mc_yesterday": "Yesterday",
 "new_tournaments": "New tournaments",
 "news_from_source": "from",
 "news_type": "News Type",
 "not_now": "Not now",
 "notifications": "Notifications",
 "notifications_disabled_description": "To receive important news and updates, please enable them in your system settings.",
 "notifications_disabled_title": "Notifications are currently disabled",
 "notify_daily": "Notify once daily",
 "notify_on_update": "Notify when a new update appears",
 "other": "Other",
 "password": "Password",
 "privacy_policy": "Privacy Policy",
 "registration_complete": "Registration is complete",
 "registration_not_finished": "Registration is not finished",
 "reset_password_button": "Reset",
 "reset_password_mail_incorrect": "The mail is not correct",
 "reset_password_successful": "Password reset. Check your e-mail",
 "reset_password_title": "Reset Password",
 "set_up": "Set up",
 "set_up_notifications_message": "Get notified about the news that matters most to you.\nYou can change this at any time in Settings.",
 "set_up_notifications_title": "Set up Notifications?",
 "settings": "Settings",
 "settings_account_deleted": "Your account has been deleted",
 "settings_log_out_success": "You've logged out of your account",
 "short_password": "Password must be at least 6 characters",
 "show_password": "Show password",
 "sign_in": "Sign in",
 "sign_in_with_google": "Sign in with Google",
 "sign_up": "Sign Up",
 "sign_up_disclaimer": "Already have an account? Sign in",
 "st_analytics": "Usage analytics",
 "st_analytics_subtitle": "Anonymous statistics help us find crashes and slow screens",
 "st_appearance": "Appearance",
 "st_appearance_dark": "Dark",
 "st_appearance_light": "Light",
 "st_appearance_system": "System",
 "st_contact_us": "Contact us",
 "st_contacts_email": "Your email",
 "st_contacts_form": "Feedback form",
 "st_contacts_intro": "Questions, ideas or something broken? Write to us — we read every message.",
 "st_contacts_message": "Message",
 "st_contacts_name": "Name",
 "st_contacts_send": "Send",
 "st_delete_account_text": "This permanently deletes your account and favourites. This cannot be undone.",
 "st_delete_account_title": "Delete account?",
 "st_guest": "Guest",
 "st_guest_mode": "Guest mode",
 "st_guest_mode_subtitle": "Sign in to sync your favourites and settings",
 "st_guest_subtitle": "Log in to keep your favourites",
 "st_language": "Language",
 "st_latest_version": "Latest version installed",
 "st_privacy_options": "Privacy options",
 "st_push_alerts": "Alerts",
 "st_push_alerts_subtitle": "Pause all alerts without changing your choices",
 "st_push_quiet_enabled": "Do not disturb",
 "st_push_quiet_from": "From",
 "st_push_quiet_subtitle": "No alerts in this window, by this device's time zone",
 "st_push_quiet_to": "To",
 "st_push_section_events": "Match alerts",
 "st_push_section_more": "More alerts",
 "st_push_section_quiet": "Quiet hours",
 "st_push_section_scope": "Which matches",
 "st_push_unavailable": "Notifications are not available on this device",
 "st_rate_us": "Rate us",
 "st_rate_us_subtitle": "Your feedback helps us improve",
 "st_section_app": "App",
 "st_section_cricket": "Cricket",
 "st_section_documents": "Documents",
 "st_section_preferences": "Preferences",
 "st_section_profile": "Profile",
 "st_section_support": "Support",
 "st_share_app": "Share the app",
 "st_share_app_subtitle": "Tell your friends about us",
 "st_sign_out_text": "You can log back in anytime — your favourites stay with your account.",
 "st_sign_out_title": "Log out?",
 "st_youtube": "YouTube videos",
 "st_youtube_subtitle": "Allow the official YouTube player to load",
 "terms_of_use": "Terms of Use",
 "time_passed_hours": "{0} hours ago",
 "time_passed_days": "{0} days ago",
 "time_passed_day": "{0} day ago",
 "time_passed_hour": "{0} hour ago",
 "time_passed_minute": "{0} minute ago",
 "time_passed_minutes": "{0} minutes ago",
 "update": "Update",
 "update_version_message": "Please click below to update app to the latest version.",
 "update_version_title": "New version available",
 "watch_video": "Watch video",
 "widget_favorites_description": "Matches of the teams you follow",
 "tg_who_wins": "Who will win?",
 "tg_votes": "{0} votes",
 "tg_vote_closed": "Voting closed",
 "tg_vote_correct": "{0}% guessed right",
 "tg_loading": "Loading…",
 "tg_error_text": "We’re having trouble loading this page",
 "tg_news_soon": "New ones will appear soon",
 "tg_news_main": "Top",
 "tg_current_over": "Current over",
 "tg_over_n": "Over {0}",
 "tg_partnership_sub": "The two batters at the crease",
 "tg_current_bowler": "Current bowler",
 "tg_bowler_sub": "Bowling to the current batters",
 "tg_balls": "Balls",
 "tg_overs": "Overs",
 "tg_economy": "Economy",
 "tg_no_live": "No live matches right now",
 "tg_updating": "updating…",
 "tg_game_hint": "+{0} for the right winner, +{1} more if fewer than {2}% picked it",
 "tg_game_see_votes": "Pick a winner to see how others voted",
 "tg_game_withdraw": "Tap your pick again to cancel it",
 "tg_game_won": "You got it right: +{0}",
 "tg_game_lost": "Not this time",
 "tg_game_void": "Match didn’t take place — no points",
 "tg_game_week": "Week",
 "tg_game_month": "Month",
 "tg_game_all": "All time",
 "tg_game_points": "Points",
 "tg_game_rank": "Rank",
 "tg_game_accuracy": "Accuracy",
 "tg_game_streak": "Streak",
 "tg_game_streak_days": "{0} days",
 "tg_game_best": "Best: {0}",
 "tg_game_freezes": "Freezes: {0} of {1}",
 "tg_game_at_risk": "Make a pick today to keep your streak",
 "tg_game_today_done": "Today’s pick is in",
 "tg_game_unranked_sign_in": "Sign in to get a place in the table — your points are saved",
 "tg_game_unranked_no_settled": "You’ll get a place after your first settled prediction",
 "tg_game_unranked_not_a_fan": "Add the club to favorites to get a place here",
 "tg_game_behind": "{0} pts to the next place",
 "tg_game_players": "{0} players",
 "tg_game_pending": "Waiting",
 "tg_game_leaderboard_empty": "No one has scored yet",
 "tg_game_you": "You",
 "tg_fans": "{0} fans",
 "tg_game_streak_one": "1 day",
 "tg_votes_one": "1 vote",
 "tg_game_name": "Your name in the table",
 "tg_game_name_change": "Change",
 "tg_game_name_save": "Save",
 "tg_game_name_hint": "2–24 letters or digits. Leave empty for the default name.",
 "tg_game_name_invalid": "This name can’t be used",
 "tg_key_stats": "Key Stats",
 "tg_key_moments": "Key moments",
 "tg_run_rate": "Run rate",
 "tg_our_estimate": "our estimate",
 "tg_preliminary_squad": "Preliminary squad",
 "tg_right_hand": "Right Hand",
 "tg_left_hand": "Left Hand",
 "tg_last_event": "Event",
 "tg_ai_summary": "AI Summary",
 "tg_more_about": "More About This",
 "tg_popular_players": "Popular players",
 "tg_latest_version": "Latest version installed",
 "tg_fours": "Fours",
 "tg_sixes": "Sixes",
 "tg_overs_short": "{0} ov",
 "tg_batters": "Batters",
 "tg_bowlers": "Bowlers",
 "tg_wicket": "Wicket",
 "tg_maiden": "Maiden",
 "tg_all_innings": "All innings",
 "tg_lg_create": "Create league",
 "tg_lg_join": "Join by code",
 "tg_lg_name_ph": "League name",
 "tg_lg_code_ph": "Invite code",
 "tg_lg_members": "{0} members",
 "tg_lg_members_title": "Members",
 "tg_lg_owner": "Owner",
 "tg_lg_invite": "Invite friends",
 "tg_lg_code": "Invite code",
 "tg_lg_copy": "Copy",
 "tg_lg_copied": "Copied",
 "tg_lg_group": "Add the bot to a group chat",
 "tg_lg_group_hint": "The bot will post the league table there once a day",
 "tg_lg_group_linked": "Group chat: {0}",
 "tg_lg_new_code": "New code",
 "tg_lg_leave": "Leave league",
 "tg_lg_leave_q": "Leave this league?",
 "tg_lg_remove": "Remove",
 "tg_lg_remove_q": "Remove {0} from the league?",
 "tg_lg_empty": "Create a league with friends or join one by code",
 "tg_lg_name_invalid": "Use 2–32 letters, no links",
 "tg_lg_code_invalid": "No league with this code",
 "tg_lg_limit": "You can be in up to 20 leagues",
 "tg_lg_full": "This league is full",
 "tg_lg_share_text": "Join my cricket predictions league «{0}»",
 "tg_lg_not_found": "League not found",
 "tg_lg_joining": "Joining the league…",
 "tg_lg_members_one": "1 member",
 "tg_error_title": "Oops, something went wrong",
 "tg_reload": "Reload",
 "tg_try_again": "Try Again",
 "tg_offline_cached": "No connection. Showing data from {0}",
 "tg_report": "Report",
 "tg_report_name": "Report name",
 "tg_report_league": "Report league name",
 "tg_report_q": "Report the name “{0}”?",
 "tg_report_text": "If several players report it, the name is hidden until we review it.",
 "tg_report_sent": "Thanks — we’ll review it",
 "tg_report_limit": "You’ve sent too many reports today",
 "tg_game_players_one": "1 player",
 "tg_world_exit": "Back to cricket",
 "tg_world_xp_progress": "{0} / {1} XP",
 "tg_world_max_level": "Max level",
 "tg_world_expires": "Until {0}",
 "tg_world_chests_more": "+{0} more",
 "tg_world_collect": "Collect",
 "tg_world_claimed": "Claimed",
 "tg_world_reward_title": "Reward!",
 "tg_world_err_chest_expired": "This chest has expired",
 "tg_world_err_task_not_done": "Finish the task first",
 "tg_world_err_unavailable": "Not available right now",
 "tg_world_err_generic": "Something went wrong. Please try again",
 "tg_world_chest_correct": "{0}/{1} correct",
 "tg_game_questions": "Match questions",
 "tg_game_q_show": "Match questions",
 "tg_game_q_hide": "Hide questions",
 "tg_game_q_all": "Show all ({0})",
 "tg_game_q_less": "Show less",
 "tg_game_q_my": "Your answer: {0}",
 "tg_game_q_won": "Correct: +{0}",
 "tg_game_q_void": "Not counted",
 "tg_game_q_line": "Line: {0}",
 "tg_game_q_result": "Result: {0}",
 "tg_game_live_title": "Play live",
 "tg_game_overs_summary": "Overs guessed: {0} of {1}",
 "tg_game_over_runs": "{0} runs",
 "tg_game_cheer_mine": "Your taps: {0}/{1}",
 "tg_game_cheer_bonus": "Bonus goes to your match chest",
 "tg_game_cheer_cap": "Tap limit for this match reached",
 "tg_game_err_over_closed": "Too late — this over is closed. Here’s the next one",
 "tg_game_err_cheer_closed": "The match is over — cheering is closed",
 "tg_world_chest_overs": "Overs guessed: {0}",
 "tg_world_chest_cheered": "📣 cheered",
 "tg_world_div_ends": "Week ends {0}",
 "tg_world_div_results": "Results {0}",
 "tg_world_div_up": "Top {0} go up",
 "tg_world_div_down": "Bottom {0} go down",
 "tg_world_div_last": "Last week: {0}",
 "tg_world_season_ends": "Ends {0}",
 "tg_world_season_best": "Best tier: {0}",
 "tg_world_season_none": "No tier yet this month",
 "tg_world_fans_n": "Fans: {0}",
 "tg_world_fans_mine": "your team",
 "tg_world_lb_open": "Open tables",
 "tg_world_lb_hide": "Hide tables",
 "tg_world_guild_members": "{0}/{1} players",
 "tg_world_guild_members_n": "Players: {0}",
 "tg_world_guild_open": "open to join",
 "tg_world_guild_closed": "join by code",
 "tg_world_guild_make_open": "Open the club to everyone",
 "tg_world_guild_make_closed": "Close the club (code only)",
 "tg_world_guild_members_title": "Members",
 "tg_world_guild_week_points": "Points this week",
 "tg_world_guild_make_helper": "Make helper",
 "tg_world_guild_make_member": "Make member",
 "tg_world_guild_settings": "Invite, Telegram group, leave",
 "tg_world_guild_join": "Join",
 "tg_world_guild_tg": "Telegram group",
 "tg_world_guild_open_hint": "Anyone can join without a code",
 "tg_world_guild_convert": "Turn into club",
 "tg_world_guild_convert_q": "Turn «{0}» into a club?",
 "tg_world_guild_convert_text": "Members stay. You can be in only one club.",
 "tg_world_err_guild_already_member": "You’re already in a club",
 "tg_world_err_guild_full": "This club is full",
 "tg_world_err_guild_closed": "This club is closed — join with a code",
 "tg_world_err_guild_member_taken": "Someone in this league is already in another club",
 "tg_world_err_guild_too_big": "Too many members for a club",
 "tg_world_err_guild_role_invalid": "This role can’t be assigned",
 "tg_error_busy": "Too many requests — please try again in a minute",
 "tg_world_energy_regen": "+1 in {0}",
 "tg_world_energy_full": "Full",
 "tg_world_energy_today": "{0}/{1} today",
 "tg_road_pts": "{0} pts",
 "tg_road_next_pts": "Step {0}: {1} pts to go",
 "tg_medals": "Medals",
 "tg_battle_jackpot": "Gold ×10 from {0} wickets",
 "tg_relic_w_crit_chance": "Critical tap chance",
 "tg_relic_w_crit_dmg": "Critical tap damage",
 "tg_relic_w_portal": "Start level after a New season",
 "tg_relic_w_drum": "Wickets per level",
 "tg_relic_w_rabbit": "Chance of gold ×10 from a wicket",
 "tg_vip_level": "VIP {0} / {1}",
 "tg_vip_effect": "+{0}% damage · +{1}% cups",
 "tg_vip_bought": "VIP {0} is yours",
 "tg_vip_paid": "Paid — your VIP level is on the way",
 "tg_vip_err_max": "VIP is already at the top level",
 "tg_contract_card": "Card level {0}/{1}",
 "tg_contract_done": "Bought this month",
 "tg_contract_paid": "Paid — the card is being raised to the top level",
 "tg_contract_err_bought": "The contract is already bought this month",
 "tg_contract_err_player": "This player is not in your squad",
 "tg_err_currency": "This step is sold for gems only",
 "tg_tasks_reset": "New tasks",
 "tg_tasks_reset_done": "Tasks replaced",
 "tg_bprof_m_vip": "VIP",
 "tg_bprof_m_patrons": "Patrons",
 "tg_patrons_title": "Patrons",
 "tg_patron_buy": "Buy",
 "tg_patron_owned": "Owned",
 "tg_patron_off": "Not available",
 "tg_patron_paid": "{0} is with you now",
 "tg_patron_err_owned": "You already have this patron",
 "tg_patron_err_off_sale": "This patron isn’t on sale right now",
 "tg_patron_err_closed": "Patrons aren’t available right now",
 "tg_patron_gifts": "Patron gifts: {0}",
 "tg_patron_gift_item": "{0} item",
 "tg_patron_gift_items": "{0} items",
 "tg_patron_gift_medal": "{0} medal",
 "tg_patron_gift_medals": "{0} medals",
 "tg_patron_get": "Get in Store",
 "tg_patron_badge": "Patron: {0}",
 "tg_clubs_by_points": "Points",
 "tg_clubs_country": "My country",
 "tg_clubs_empty": "No clubs in the table yet: a club needs {0} active fans this week",
 "tg_clubs_active_n": "Active: {0}",
 "tg_clubs_needs_team": "Pick your team to join its club",
 "tg_clubs_rewards": "Rewards for places",
 "tg_clubs_place": "Place {0}",
 "tg_clubs_last_week": "Last week: place {0}",
 "tg_clubs_last_unpaid": "no reward: you were not active",
 "tg_clubs_open": "Open clubs",
 "tg_bprof_m_rank": "Rank",
 "tg_rank_title": "Rank {0}/{1}",
 "tg_rank_hint": "Each rank: +{0}% damage for this player. Now: +{1}%.",
 "tg_rank_up": "Rank up",
 "tg_rank_max": "Top rank for this rarity",
 "tg_rank_done": "{0}: rank {1}",
 "tg_rank_err_max": "This player is at the top rank",
 "tg_err_expert": "Not enough expert points",
 "tg_relic_err_locked": "Buy the first level of this relic first",
 "tg_bprof_cups_bank": "Cups in the bank",
 "tg_bprof_cups_invested": "Cups spent on relics",
 "tg_bprof_each": "+{0}% damage each",
 "tg_bprof_tips": "Tips",
 "tg_store_expert_paid": "Paid: +{0} expert points",
 "tg_expert": "Expert points",
 "tg_expert_level": "Expert level {0}",
 "tg_expert_bonus": "+{0}% medals from match chests",
 "tg_expert_next": "Earned {0} of {1} to the next level",
 "tg_expert_hint": "One point for every correct match answer. Points are earned, not gifted.",
 "tg_login_claim": "Claim day {0}",
 "tg_login_done": "Come back tomorrow for day {0}",
 "tg_login_day": "Day {0}",
 "tg_login_open": "Open",
 "tg_store_got_gold": "Bought: +{0} gold",
 "tg_tasks_until": "until {0}",
 "tg_tasks_points": "Task points today: {0}",
 "tg_tasks_points_hint": "+{0} points for every task you claim. Points open gem sets and reset each day.",
 "tg_tasks_set_claimed": "Set claimed: +{0} gems",
 "tg_tasks_err_set": "Not enough task points for this set yet",
 "tg_store_good_locked": "Not available yet",
 "tg_store_good_active": "Active",
 "tg_store_good_gold": "You get {0} gold now",
 "tg_store_err_good": "This item is not available right now",
 "tg_daily_armor": "Hit! Armor {0}",
 "tg_daily_armor_hint": "Break the armor with your taps first — the team cannot hit through it.",
 "tg_daily_armor_n": "Armor: {0} taps",
 "tg_daily_locked": "The captain rests until {0}. A fight now costs gems.",
 "tg_daily_start_now": "Fight · free",
 "tg_battle_thrall": "Thrall",
 "tg_battle_taps_only": "taps only",
 "tg_star_next": "Star {0}",
 "tg_star_need": "Needs all six slots in T{0} or higher, all of one tier. The set burns, the star stays.",
 "tg_star_mult": "Each star: ×{0} damage",
 "tg_star_missing": "Empty: {0}",
 "tg_star_mixed": "Tiers differ: all six must be one tier",
 "tg_star_low": "Set is T{0}, needs T{1}",
 "tg_star_up": "Burn set · ★{0}",
 "tg_star_confirm": "Tap again: six items burn",
 "tg_star_done": "{0}: star {1}",
 "tg_star_err_incomplete": "The set is not ready: six items of one tier",
 "tg_kit_none_yet": "Kit drops from level {0}.",
 "tg_skill_k_cap_own": "+{0}% tap damage",
 "tg_skill_k_cap_mult": "×{0} tap damage",
 "tg_team_skills": "Skills by level",
 "tg_team_skills_taken": "Unlocked: {0}",
 "tg_team_skill_at": "Lv {0}",
 "tg_skill_k_own": "+{0}% own damage",
 "tg_skill_k_tap": "Captain’s tap: +{0}% of team damage",
 "tg_skill_k_team": "+{0}% damage for the whole team",
 "tg_skill_k_mult": "×{0} own damage",
 "tg_team_to_skill": "To skill",
 "tg_relic_w_cups": "Cups from legends and big bosses",
 "tg_relic_w_legend": "Legend chance",
 "tg_relic_w_boss_hp": "Bosses are weaker by",
 "tg_relic_special_at": "Opens at level {0}",
 "tg_relic_special": "Special relic: earned, not bought",
 "tg_relic_special_next": "Next level at level {0}",
 "tg_relics_reset": "Reset relics · +{0}",
 "tg_relics_reset_hint": "All bought relics go back to level 0. You get {0}% of the cups spent ({1} of {2}).",
 "tg_relics_reset_confirm": "Tap again to reset",
 "tg_relics_reset_done": "Relics reset: +{0} cups",
 "tg_relic_err_special": "This relic cannot be bought",
 "tg_relic_err_empty": "Nothing to reset yet",
 "tg_relic_new_cost": "A new relic costs {0}",
 "tg_cups_pending": "Waiting: {0}",
 "tg_cups_pending_hint": "Cups from legends and big bosses wait and give no power yet. A new season or a Bright season activates them.",
 "tg_bright_season": "Bright season · {0}",
 "tg_bright_season_hint": "Activates waiting cups now, nothing is reset.",
 "tg_bright_season_done": "Bright season: {0} cups activated",
 "tg_season_err_nothing_pending": "No cups are waiting",
 "tg_bprof_cups_pending": "Cups waiting",
 "tg_community_joined": "You’re in the stands",
 "tg_community_members": "In the chat: {0}",
 "tg_community_in_stands": "In the fan chat",
 "tg_world_guild_club_choose": "Choose",
 "tg_world_err_guild_follows_team": "Your club follows your team — change your team to move",
 "tg_world_err_country_invalid": "Couldn’t pick this country — try another",
 "tg_world_nation_empty": "No country has enough fans yet",
 "tg_community_open": "Open {0} in Telegram",
 "tg_community_my_nation": "My country’s room",
 "tg_community_my_club": "My club’s room",
 "tg_store_bought": "Bought",
 "tg_store_boost_bought": "Gold boost is on",
 "tg_store_item_set_bought": "Item set added to your kit bag",
 "tg_store_stars_closed": "Gems for Stars — coming soon",
 "tg_store_stars_unavailable": "Payments are unavailable right now",
 "tg_store_stars_in_telegram": "Payment works inside Telegram",
 "tg_store_stars_paid": "Paid — {0} gems are on the way",
 "tg_store_champion_owned": "you have {0}",
 "tg_store_boost_until": "On until {0}",
 "tg_store_boost_extend": "Extend",
 "tg_store_from": "from {0}",
 "tg_store_per_hour": "{0} / h",
 "tg_store_err_champion_bought": "You already bought this week's champion",
 "tg_store_err_unavailable": "This item isn't sold right now",
 "tg_streak_at_risk": "Don't lose your {0}-day streak — make a prediction today",
 "tg_streak_today_done": "Today counts ✓",
 "tg_streak_best": "Best: {0}",
 "tg_streak_freezes": "Freezes: {0}/{1}",
 "tg_streak_bet_offer": "Keep the streak {0} more match days — win {1}",
 "tg_streak_bet_rules": "Days without matches don't count. Lose the streak or miss {0} days — the bet is gone.",
 "tg_streak_bet_place": "Bet {0}",
 "tg_streak_bet_placed": "Bet placed — keep the streak going",
 "tg_streak_bet_active": "Bet in play: {0}/{1} match days",
 "tg_streak_bet_until": "until {0}",
 "tg_streak_bet_win": "win {0}",
 "tg_streak_bet_won": "Last bet won: +{0}",
 "tg_streak_bet_lost": "Last bet was lost",
 "tg_streak_balance": "You have {0}",
 "tg_streak_err_active": "You already have a bet in play",
 "tg_streak_err_closed": "Streak bets are closed right now",
 "tg_live_mult": "Live · damage ×{0}",
 "tg_live_toss_in": "Toss in {0}",
 "tg_live_predict": "Make a prediction",
 "tg_live_per_wicket": "+{0} per wicket",
 "tg_live_damage": "Your damage is ×{0} while the match is live",
 "tg_live_paid": "Already paid: {0} wickets · +{1}",
 "tg_live_predicted": "Your prediction is in — every wicket pays you",
 "tg_live_need_predict": "Make a prediction to get gold for every wicket",
 "tg_live_closed": "Predictions are closed for this match",
 "tg_friends_invited_empty": "No one yet — send your invite",
 "tg_friends_guild_share_text": "Join my club {0} in the cricket world",
 "tg_lg_closed": "Friend leagues are gone — your group is now the club",
 "tg_world_err_guild_requests_limit": "You already have 5 requests waiting — withdraw one first",
 "tg_world_guild_request": "Ask to join",
 "tg_world_guild_requested": "Request sent — the club leaders will decide",
 "tg_world_guild_withdraw": "Withdraw",
 "tg_world_guild_withdrawn": "Request withdrawn",
 "tg_world_guild_request_waiting": "Your request is waiting",
 "tg_world_guild_requests": "Join requests · {0}",
 "tg_world_guild_accept": "Accept",
 "tg_world_guild_decline": "Decline",
 "tg_week_until": "Until {0}",
 "tg_week_open_guild": "Open club",
 "tg_bmap_fog": "The fog will lift as you go further",
 "tg_road_sources": "Battle {0} · Predictions {1} · Logins {2}",
 "tg_road_gold_note": "Gold is counted by your battle level when you collect",
 "tg_map_event_until": "until {0}",
 "tg_daily_fought": "{0} fought",
 "tg_daily_table_empty": "No one has fought today's captain yet — be the first",
 "tg_battle_legend": "Legend",
 "tg_camp_claimed_medals": "Back from camp: +{0} medals",
 "tg_camp_skip": "Back now",
 "tg_camp_err_back": "The player is already back",
 "tg_rarity_up": "Raise rarity",
 "tg_rarity_upped": "Rarity raised: {0}",
 "tg_rarity_err_max": "Already the top rarity",
 "tg_err_medals": "Not enough medals",
 "tg_skill_reset": "Reset",
 "tg_skill_err_active": "The skill is still active",
 "tg_skill_err_ready": "The skill is already ready",
 "tg_daily_pay_gems": "Try for gems",
 "tg_world_level_up": "Level {0}!",
 "tg_road_err_locked": "Not enough XP for this step yet",
 "tg_road_next": "Step {0}: {1} XP to go",
 "tg_sound_on": "Sound on",
 "tg_sound_off": "Sound off",
 "tg_friends_attached": "You joined by a friend’s invite",
 "tg_friends_gifts": "Gifts from friends",
 "tg_friends_waiting": "{0} waiting",
 "tg_friends_none_waiting": "No gifts yet",
 "tg_friends_per_day": "Up to {0} a day, the rest wait for tomorrow",
 "tg_friends_claim": "Collect +{0}",
 "tg_friends_invite": "Invite a friend",
 "tg_friends_your_code": "Your code",
 "tg_friends_share": "Send invite",
 "tg_friends_share_text": "Join me in the cricket world — we both get medals",
 "tg_friends_copy": "Copy code",
 "tg_friends_copied": "Code copied",
 "tg_friends_reward_you": "For you",
 "tg_friends_reward_friend": "For your friend",
 "tg_friends_have_code": "Got a friend’s code?",
 "tg_friends_code_placeholder": "Code",
 "tg_friends_attach": "Apply",
 "tg_friends_list": "Friends",
 "tg_friends_empty": "Friends are people from your leagues and club, and those you invite",
 "tg_friends_level": "Level {0}",
 "tg_friends_gift": "Gift",
 "tg_friends_sent": "Sent",
 "tg_friends_invited_by_me": "Invited by you",
 "tg_friends_invited_me": "Invited you",
 "tg_friends_ref_waiting": "Reward at level {0}",
 "tg_friends_ref_done": "Reward received",
 "tg_friends_gift_sent": "Energy sent",
 "tg_friends_err_none": "No gifts to collect",
 "tg_friends_err_limit": "Today’s gift limit is reached — come back tomorrow",
 "tg_friends_err_not_friend": "This player is no longer your friend",
 "tg_friends_err_code": "There is no such code",
 "tg_friends_err_self": "That’s your own code",
 "tg_friends_err_already": "You already have an inviting friend",
 "tg_friends_err_late": "A code can only be added in your first days",
 "tg_swipe_hint": "Swipe toward the team you back",
 "tg_swipe_draw_hint": "Swipe up for a draw",
 "tg_swipe_skip": "Skip",
 "tg_swipe_left": "{0} to pick",
 "tg_swipe_agree": "{0}% picked the same",
 "tg_swipe_first": "You are the first to pick",
 "tg_swipe_done_title": "All matches picked!",
 "tg_swipe_done_text": "New matches appear every day — come back for more",
 "tg_swipe_my_picks": "Your picks",
 "tg_swipe_change": "Tap a match to change your pick or answer match questions",
 "tg_swipe_won": "Won +{0}",
 "tg_swipe_lost": "Missed",
 "tg_swipe_error": "Couldn’t save the pick — try again",
 "tg_gems": "Gems",
 "tg_gems_earn": "How to earn",
 "tg_gems_spend": "Spend",
 "tg_gems_refill": "Full energy",
 "tg_gems_refill_full": "Energy is already full",
 "tg_gems_claim": "Collect",
 "tg_gems_claimed": "Collected",
 "tg_gems_never_sold": "Earn gems in the game or buy them for Stars in the store",
 "tg_gems_err_not_enough": "Not enough gems",
 "tg_gems_err_locked": "This milestone isn’t reached yet",
 "tg_gems_err_claimed": "Already collected",
 "tg_gems_err_energy_full": "Energy is already full",
 "tg_so_table": "Today's table",
 "tg_gold": "Gold",
 "tg_battle_level": "Level {0}",
 "tg_battle_wicket": "Wicket {0} of {1}",
 "tg_battle_boss": "Boss",
 "tg_battle_big_boss": "Big boss",
 "tg_battle_hint": "Tap the wicket to bowl",
 "tg_battle_dps": "{0}/s",
 "tg_battle_map": "Level map",
 "tg_battle_profile": "Power profile",
 "tg_battle_challenge": "Challenge the boss",
 "tg_battle_boss_failed": "The boss held — gather gold and challenge again",
 "tg_battle_offline_title": "While you were away",
 "tg_battle_offline": "Your team kept breaking wickets for {0} min",
 "tg_battle_offline_ok": "Great",
 "tg_team_level": "Lv {0}",
 "tg_team_total": "Team: {0}/s",
 "tg_team_hire": "Hire",
 "tg_team_upgrade": "Upgrade",
 "tg_team_next": "Next player",
 "tg_team_milestone": "Milestone at Lv {0}",
 "tg_team_max": "Max",
 "tg_team_err_gold": "Not enough gold",
 "tg_team_err_locked": "Hire the previous player first",
 "tg_bmap_here": "You are here",
 "tg_bmap_best": "Best: level {0}",
 "tg_bmap_auto": "Auto-advance",
 "tg_bprof_dps": "Team damage per second",
 "tg_bprof_tap": "Tap damage",
 "tg_bprof_captain": "Captain level",
 "tg_bprof_hired": "Players in the team",
 "tg_bprof_multipliers": "Multipliers",
 "tg_bprof_counters": "Records",
 "tg_bprof_m_rarity": "Rarity",
 "tg_bprof_m_gear": "Gear",
 "tg_bprof_m_in_form": "In form",
 "tg_bprof_m_cups": "Season cups",
 "tg_bprof_m_relics": "Relics",
 "tg_bprof_m_guild": "Club",
 "tg_bprof_wickets": "Wickets broken",
 "tg_bprof_bosses": "Bosses beaten",
 "tg_bprof_best": "Best level",
 "tg_bprof_season": "Season",
 "tg_bprof_cups": "Cups",
 "tg_kit_bag": "Kit bag",
 "tg_kit_tier": "T{0}",
 "tg_kit_level_cap": "Lv {0}/{1}",
 "tg_kit_in_form": "In form",
 "tg_kit_no_stars": "No stars yet",
 "tg_kit_star_hint": "Kit all six slots for a star: stars = the lowest tier of the full set.",
 "tg_kit_equip": "Equip",
 "tg_kit_unequip": "Take off",
 "tg_kit_none_slot": "Nothing for this slot in the bag yet",
 "tg_kit_empty": "The bag is empty. Kit drops from wickets and bosses.",
 "tg_kit_wear_hint": "Equip from a player’s profile in Team. {0} identical items merge into one of the next tier.",
 "tg_kit_merge_title": "Ready to merge",
 "tg_share_league": "Share league card",
 "tg_kit_merge": "Merge",
 "tg_kit_merge_have": "{0} of {1} needed",
 "tg_kit_merged": "{0} upgraded to T{1}",
 "tg_kit_drop": "Kit dropped: +{0} in the bag",
 "tg_kit_lost": "Bag is full: {0} item(s) lost. Merge or equip to make room.",
 "tg_kit_err_not_hired": "Hire this player first",
 "tg_kit_err_full": "The bag is full",
 "tg_kit_err_merge": "Not enough identical items to merge",
 "tg_team_err_capped": "Rarity level cap reached",
 "tg_team_capped": "Max level",
 "tg_team_bonus": "All: {0}",
 "tg_bprof_m_stars": "Stars",
 "tg_bprof_m_team": "Team bonus",
 "tg_skill_locked": "Lv {0}",
 "tg_skill_err_locked": "Level up the captain to unlock this skill",
 "tg_skill_err_cooldown": "The skill is still recharging",
 "tg_cups": "Cups",
 "tg_relics_open": "Relics",
 "tg_relics_hint": "Each cup gives +{0}% damage. A cup spent on a relic stops giving it — the relic gives its own bonus instead.",
 "tg_relic_next": "Next level: {0}",
 "tg_relic_w_dps": "Team damage",
 "tg_relic_w_tap": "Tap damage",
 "tg_relic_w_gold": "Gold",
 "tg_relic_w_boss": "Boss timer",
 "tg_relic_w_drop": "Kit drop chance",
 "tg_relic_w_offline": "Income while away",
 "tg_relic_err_cups": "Not enough cups",
 "tg_relic_err_max": "This relic is at its top level",
 "tg_season_title": "New season",
 "tg_season_cta": "New season · +{0}",
 "tg_season_gain": "You will get {0} cups; each cup is +{1}% damage for good.",
 "tg_season_resets": "Starts over:",
 "tg_season_keeps": "You keep:",
 "tg_season_start": "Start season {0}",
 "tg_season_from": "Opens at level {0}",
 "tg_season_started": "Season {0} has started: +{1} cups",
 "tg_season_err_locked": "The new season is not open yet",
 "tg_season_p_level": "level",
 "tg_season_p_gold": "gold",
 "tg_season_p_team": "team levels",
 "tg_season_p_captain": "captain level",
 "tg_season_p_skills": "skills",
 "tg_season_p_items": "kit",
 "tg_season_p_rarity": "rarity",
 "tg_season_p_relics": "relics",
 "tg_season_p_cups": "cups",
 "tg_season_p_record": "best level ever",
 "tg_bprof_record": "Record level",
 "tg_daily_open": "Captain of the day",
 "tg_daily_wins": "Beaten {0}×",
 "tg_daily_reward": "Win: one of your {0} weakest players goes up a rarity.",
 "tg_daily_start_free": "Fight · free ({0} left)",
 "tg_daily_start": "Fight again ·",
 "tg_daily_hit": "Tap to bowl at the captain",
 "tg_daily_hint": "Your team hits too — keep tapping!",
 "tg_daily_counting": "Counting the result…",
 "tg_daily_won": "You beat the captain of the day!",
 "tg_daily_won_rarity": "Victory! A player went up: {0} → {1}",
 "tg_daily_won_gold": "Victory! +{0} gold",
 "tg_daily_lost": "Time is up — the captain held on. Try again!",
 "tg_daily_err_fighting": "The fight is already on",
 "tg_daily_err_no_player": "No captain of the day yet — come back later",
 "tg_daily_err_not_started": "The fight has not started",
 "tg_rarity_common": "Common",
 "tg_rarity_rare": "Rare",
 "tg_rarity_epic": "Epic",
 "tg_rarity_legendary": "Legendary",
 "tg_camp_open": "Training camp",
 "tg_camp_hint": "A player in camp does not hit, but brings back gold and kit.",
 "tg_camp_away": "In camp",
 "tg_camp_claim": "Collect",
 "tg_camp_claimed": "Back from camp: +{0} gold, {1} kit",
 "tg_camp_send_title": "Send to camp",
 "tg_camp_hours": "How long",
 "tg_camp_h": "{0} h",
 "tg_camp_nobody": "Hire players in Team to send them to camp",
 "tg_camp_send": "Send",
 "tg_camp_err_busy": "This player is already in camp",
 "tg_camp_err_full": "All camp places are taken",
 "tg_camp_err_not_back": "Not back from camp yet",
 "tg_team_in_camp": "In camp until {0}",
 "tg_ach_tier": "Tier {0} of {1}",
 "tg_myteam_title": "My team",
 "tg_myteam_pick": "Pick your team",
 "tg_myteam_today": "Match day ×{0}",
 "tg_myteam_hint": "On the day your team plays a real match, income while you are away is ×{0}. One team only.",
 "tg_myteam_current": "Your team now",
 "tg_myteam_free": "You can change it for free now; after that — once every {0} days.",
 "tg_myteam_paid": "Free change on {0}; earlier — for {1} gems.",
 "tg_myteam_confirm": "Change ·",
 "tg_myteam_done": "Your team is set",
 "tg_myteam_none": "No teams to pick yet",
 "tg_club_group_country": "Clubs of your country",
 "tg_club_group_country_of": "Clubs of {0}",
 "tg_club_group_other": "Other clubs",
 "tg_event_points": "{0} points",
 "tg_event_rank": "Place {0}",
 "tg_event_no_rank": "Not ranked yet",
 "tg_event_rules": "Wicket +{0} · Boss +{1} · Captain of the day +{2}",
 "tg_event_ends": "Ends in {0}",
 "tg_event_milestones": "Milestones",
 "tg_event_claim": "Collect",
 "tg_event_last": "Last week",
 "tg_event_place": "Place reward: {0}",
 "tg_event_table": "This week",
 "tg_event_claimed": "Collected: +{0} gold",
 "tg_event_err_nothing": "Nothing to collect yet",
 "tg_gboss_err_no_guild": "Join a club to fight its boss",
 "tg_gboss_err_no_attempts": "No attempts left today",
 "tg_gboss_no_guild": "The whole club fights this boss together. Join a club first.",
 "tg_gboss_find_guild": "Find a club",
 "tg_gboss_stage": "Boss #{0}",
 "tg_gboss_killed": "Killed this week: {0}",
 "tg_gboss_start": "Attack · {0} left today",
 "tg_gboss_claim": "Collect rewards · {0}",
 "tg_gboss_bonus": "Club bonus: +{0}% team power",
 "tg_gboss_bonus_hint": "+{0}% for every boss your club kills, up to {1}.",
 "tg_gboss_damage": "Damage this week",
 "tg_gboss_dealt": "You dealt {0}",
 "tg_gboss_dealt_kills": "You dealt {0} and finished off {1}!",
 "tg_gboss_hit": "Tap to hit the club boss",
 "tg_gboss_hint": "Your damage goes into the club total right away.",
 "tg_gboss_next": "Next kill: +{0}",
 "tg_loot_title": "Collected items",
 "tg_loot_text": "Your team found these in battle:",
 "tg_loot_empty": "Nothing yet — kit drops from wickets and bosses.",
 "tg_loot_to_kit": "Open kit bag",
 "tg_skills_close": "Close skills",
 "tg_battle_offline_items": "Your team also found {0} item(s) — they are in the loot bag.",
 "tg_ach_gems_claimed": "+{0} gems",
 "tg_captain_hint": "Your hero: every tap hits with the captain’s power",
 "tg_splash_loading": "Preparing the arena…",
 "tg_world_guild_members_shown": "top {0} of {1}",
 "tg_club_place_title": "Club this week",
 "tg_club_tile_world": "In the world",
 "tg_club_tile_active": "Active fans",
 "tg_club_needs_active": "{0} more active fans — and the club enters the table",
 "tg_ad_double": "Watch an ad · ×2",
 "tg_ad_loading": "Loading the ad…",
 "tg_ad_checking": "Checking the view…",
 "tg_ad_unavailable": "No ad right now — try again later",
 "tg_ad_not_counted": "The ad wasn't counted — try again",
 "tg_ad_later": "The gold will arrive as soon as the view is confirmed",
 "tg_ad_doubled": "Gold doubled — thanks for watching!",
 "tg_videos_by_team": "By team",
 "tg_videos_latest": "Latest videos",
 "tg_ad_limit": "Today's ×2 limit is used up — come back tomorrow",
 "tg_ads_entry": "Boosts",
 "tg_ads_title": "Free boosts for an ad",
 "tg_ads_damage_desc": "Team and tap damage ×{0} for {1} min",
 "tg_ads_gold_desc": "Gold from wickets ×{0} for {1} min",
 "tg_ads_active": "Now ×{0} · {1} left",
 "tg_ads_skills_desc": "Reset all skill cooldowns",
 "tg_ads_left": "{0} of {1} left today",
 "tg_ads_watch": "Watch",
 "tg_ads_done_skills": "Skill cooldowns reset",
 "tg_ads_done_skip": "Time jump: +{0} gold",
 "tg_ads_limit": "This boost is used up for today — come back tomorrow",
 "tg_ads_nothing_to_reset": "No skills on cooldown",
 "tg_world_err_locked_level": "Opens at a higher level",
 "tg_battle_offline_levels": "Your team passed {0} levels",
 "tg_battle_offline_stop_boss": "It stopped at a boss — beat it yourself",
 "tg_battle_offline_stop_thrall": "It stopped at a Thrall — only taps beat it",
 "tg_battle_offline_stop_cap": "That's the most for one time away",
 "tg_bprof_m_ads": "Ad boost",
 "tg_store_got_gold_levels": "Bought: +{0} gold, +{1} levels",
 "tg_ads_later": "The reward will arrive as soon as the view is confirmed",
 "tg_push_game": "Game messages",
 "tg_push_game_subtitle": "Reminders from the game in this chat",
 "tg_push_match": "Match messages",
 "tg_push_match_subtitle": "Start, result and toss of your teams' matches",
 "tg_ad_tomorrow": "tomorrow",
 "tg_ad_too_soon": "Next ad in {0} s",
 "tg_ad_place_limit": "Ad views for today are used up — come back tomorrow",
 "tg_login_claim_first": "Claim today's day first",
 "tg_login_missed": "Missed days: {0}",
 "tg_login_catchup": "Restore a day for an ad",
 "tg_login_caught_up": "Day restored: {0}",
 "tg_login_caught_up_plain": "Day restored",
 "tg_daily_ad_retry": "One more try for an ad",
 "tg_daily_ad_done": "Extra try unlocked — fight!",
 "tg_tasks_reset_ad": "New set for an ad",
 "tg_camp_skip_ad": "Back now for an ad",
 "tg_radar_about": "How the profile is built",
 "tg_played_for": "Played for",
 "tg_matches_n": "{0} matches",
 "tg_runs_n": "{0} Runs",
 "tg_split_type": "Type",
 "tg_split_left_arm": "Left-Arm",
 "tg_split_right_arm": "Right-Arm",
 "tg_split_pace": "Pace",
 "tg_split_spin": "Spin",
 "tg_split_left_hand": "vs LHB",
 "tg_split_right_hand": "vs RHB",
 "tg_split_dot": "Dot",
 "tg_innings": "Innings",
 "tg_batting_average": "Batting Average",
 "tg_half_centuries": "Half-centuries",
 "tg_centuries": "Centuries",
 "tg_not_out": "Not Out",
 "tg_economy_rate": "Economy Rate",
 "tg_bowling_average": "Bowling Average",
 "tg_maidens": "Maidens",
 "tg_four_wicket_hauls": "Four-Wicket Hauls",
 "tg_ten_wicket_hauls": "Ten-Wicket Hauls",
 "tg_career_highest_score": "Highest Score",
 "tg_career_strike_rate": "Strike Rate",
 "tg_career_best_bowling": "Best Bowling",
 "tg_all_leagues": "All leagues",
 "tg_all_seasons": "All seasons",
 "tg_tutorial_skip": "Skip tutorial",
 "tg_tutorial_ok": "Got it",
 "tg_tutorial_next": "Next",
 "tg_tutorial_close": "Close",
 "tg_tutorial_how_to_play": "How to play",
 "tg_tutorial_wait_gold": "{0} more gold — hit the wicket",
 "tg_home_screen_add": "Add to Home Screen",
 "tg_home_screen_added": "Already on Home Screen",
 "tg_home_screen_title": "Cricket on your Home Screen",
 "tg_home_screen_text": "Open live scores in one tap — no need to look for the bot.",
 "tg_home_screen_later": "Not now",
 "tg_pick_teams_title": "Choose your teams",
 "tg_pick_teams_choose": "Choose teams",
 "tg_pick_teams_empty": "Picks aren’t available right now — try again later.",
 "tg_duel_title": "{0} vs {1}",
 "tg_duel_dismissals": "Dismissals",
 "tg_duel_boundaries": "4s / 6s",
 "tg_duel_dot_percent": "Dot balls",
 "tg_duel_period": "Period",
 "tg_duel_not_enough": "Not enough data yet",
 "tg_offer_title": "Special offer",
 "tg_offer_kind_starter": "Starter pack",
 "tg_offer_kind_coach": "Coach pack",
 "tg_offer_kind_captain": "Captain pack",
 "tg_offer_kind_champion": "Champion pack",
 "tg_offer_ends": "Ends in {0}",
 "tg_offer_gems": "{0} gems",
 "tg_offer_item_sets": "Item sets ×{0}",
 "tg_offer_boost": "Gold boost {0} h",
 "tg_offer_medals": "{0} medals",
 "tg_offer_buy": "Buy",
 "tg_offer_paid": "Paid — the pack is on its way",
 "tg_country_pick_title": "Choose your country",
 "tg_country_pick_bonus": "+{0} 💎 and +{1} % damage forever",
 "tg_country_pick_error": "Couldn't save. Try again",
 "tg_country_bonus": "Country bonus: {0}",
 "tg_country_damage": "+{0} % damage",
 "tg_world_next_opens": "{0} — opens at level {1}",
 "tg_bot_live_cannot_write": "The bot can't message you. Open the bot chat and tap Start",
 "tg_bot_live_finished": "This match is over",
 "tg_bot_live_too_many": "You're following the most matches you can in chat",
 "tg_bot_live_retry": "Try again",
 "tg_bot_live_title": "Live score in chat",
 "tg_bot_live_hint": "We'll post the score in the bot chat and update it during the match",
 "tg_bot_live_on_toast": "We'll post the score in the bot chat",
 "tg_bot_live_bell_off": "Live score in chat: off",
 "tg_bot_live_bell_on": "Live score in chat: on",
 "tg_match_reactions": "Reactions",
 "tg_match_reactions_count": "Reactions: {0}",
 "tg_match_reaction_mine": "Your reaction: {0}",
 "tg_match_reactions_limit": "Too many reactions — try again in a minute",
 "tg_kit_merge_recipe": "{0} × {1} → 1 × {2} · you'll get {3}",
 "tg_kit_merge_how_many": "How many to merge",
 "tg_kit_merge_n": "Merge {0}",
 "tg_kit_merged_n": "{0} × {1} upgraded to T{2}",
 "tg_reminders_title": "Turn on reminders?",
 "tg_reminders_text": "We'll tell you when your bank is full and your match starts.",
 "tg_reminders_yes": "Yes",
 "tg_reminders_later": "Later",
 "tg_elite_title": "Elite",
 "tg_elite_shards": "Shards: {0} of {1}",
 "tg_elite_recycle": "Recycle",
 "tg_elite_recycle_needed": "{0} needed",
 "tg_elite_recycle_title": "Recycle shards",
 "tg_elite_recycle_recipe": "{0} × {1} → {2} × Tier {3}",
 "tg_elite_recycle_how_many": "How many to recycle",
 "tg_elite_recycle_n": "Recycle {0}",
 "tg_elite_recycled": "You got: {0}",
 "tg_elite_recycled_plain": "Shards recycled",
 "tg_elite_role_batter": "Batter",
 "tg_elite_role_bowler": "Bowler",
 "tg_elite_role_allrounder": "All-rounder",
 "tg_elite_role_keeper": "Wicket-keeper",
 "tg_elite_err_not_enough": "Not enough spare shards",
 "tg_elite_err_not_owned": "Collect this hero first",
 "tg_elite_err_invalid": "Choose how many to recycle",
 "tg_elite_err_not_found": "This hero is no longer available",
 "tg_login_elite": "{0} shards of {1}",
 "tg_fav_day": "{0}, {1}",
 "tg_fav_vs": "vs {0}",
 "rec_win_pair": "{0} v {1}",
 "tg_share_vs_pair": "{0} vs {1}",
 "tg_fav_at": "{0} at {1}",
 "tg_fav_pts": "{0} pts",
 "tg_fav_pts_unit": "pts",
 "tg_fav_next_tba": "Next match TBA",
 "tg_fav_find_team": "Find Your Team",
 "tg_fav_find_team_text": "Search by team or country to get started",
 "tg_fav_find_league": "Find Your League",
 "tg_fav_find_league_text": "Search by league or country to get started",
 "tg_match_tab_predictions": "Predictions",
 "tg_fav_find_player": "Find a Player",
 "tg_fav_find_player_text": "Search by player name to get started",
 "tg_fav_results_one": "{0} result",
 "tg_fav_results": "{0} results",
 "tg_fav_nothing_text": "Try a shorter query, or browse the catalogue.",
 "tg_fav_open_catalogue": "Open catalogue",
 "tg_back": "Back",
 "tg_premium_price_month": "{0} ★ / month",
 "tg_premium_price_days": "{0} ★ / {1} days",
 "tg_premium_subscribe": "Subscribe for {0} ★",
 "tg_premium_not_now": "Not now",
 "tg_premium_active_until": "Premium active until {0}",
 "tg_premium_active": "Premium is active",
 "tg_premium_plan_owned": "You already have this plan",
 "tg_premium_already_active": "Premium is already active",
 "tg_premium_pending": "Payment received — Premium will turn on in a moment.",
 "tg_premium_cancelled": "Payment cancelled",
 "tg_premium_failed": "Payment didn’t go through. Try again.",
 "tg_premium_unavailable": "Subscription isn’t available right now.",
 "tg_paywall_badge": "CRICKET PREMIUM",
 "tg_paywall_title": "Every ball. Every stat. No ads.",
 "tg_paywall_subtitle": "Live scores, scorecards and news",
 "tg_paywall_benefit_ads": "No banners or video ads",
 "tg_paywall_benefit_action": "Straight to the action",
 "tg_paywall_benefit_support": "Support Cricket News",
 "tg_paywall_benefit_stats": "Rankings, records and player comparison",
 "tg_premium_lock_unlock": "Unlock with Premium",
 "tg_premium_lock_unavailable": "Premium is not available right now",
 "tg_premium_lock_rankings": "Team rankings in Test, ODI and T20I with Premium",
 "tg_premium_lock_records": "All-time batting and bowling records with Premium",
 "tg_premium_lock_compare": "Compare players side by side with Premium",
 "tg_premium_locked": "Premium",
 "tg_premium_plan_month": "Monthly",
 "tg_premium_plan_year": "Yearly",
 "tg_premium_plan_days": "{0} days",
 "tg_premium_price_year": "{0} ★ / year",
 "tg_premium_renews_every": "{0} ★ every {1} days. Cancel anytime in Telegram.",
 "tg_premium_once_days": "One payment, {0} days. No auto-renewal.",
 "tg_premium_buy": "Pay {0} ★",
 "tg_premium_stars_in_telegram": "Stars — in Telegram",
 "tg_premium_manage": "Manage in Telegram",
 "tg_paywall_terms": "Terms",
 "tg_paywall_privacy": "Privacy",
 "tg_paywall_close": "Close",
 "tg_sub_active_until": "Active until {0}",
 "tg_sub_manage_text": "Your subscription is paid with Telegram Stars. To cancel it, open Telegram → Settings → My Stars.",
 "tg_video_blocks": "Video blocks",
 "tg_video_blocks_subtitle": "Turn off video loading",
 "tg_get_app_text": "Sign in to the app with Telegram — your world and purchases will be there",
 "tg_get_app_app_store": "App Store",
 "tg_get_app_google_play": "Google Play",
 "tg_onb_clear": "Clear",
 "tg_chat_open": "Open chat",
 "tg_chat_empty": "Be the first to say hi 👋",
 "tg_chat_no_country": "Pick your country to chat with its fans",
 "tg_chat_choose_country": "Choose your country",
 "tg_chat_placeholder": "Message…",
 "tg_chat_send": "Send",
 "tg_chat_too_fast": "Too fast, wait {0} s",
 "tg_chat_reconnecting": "Reconnecting…",
 "tg_chat_not_sent": "Message not sent",
 "tg_chat_report": "Report",
 "tg_chat_hide": "Hide this player",
 "tg_chat_copy": "Copy",
 "tg_chat_reported": "Thanks, we'll review it",
 "tg_chat_muted": "You can write again in {0} h",
 "tg_chat_action_failed": "Something went wrong. Try again",
 "tg_tab_favs": "Favs",
 "tg_prev_month": "Previous month",
 "tg_next_month": "Next month",
 "tg_not_found": "Not found",
 "tg_dur_dh": "{0}d {1}h",
 "tg_dur_hm": "{0}h {1}m",
 "mc_table_col_played": "PL",
 "mc_table_col_games": "G",
 "mc_table_col_won": "W",
 "mc_table_col_lost": "L",
 "mc_table_col_points": "PT",
 "mc_rank_col_points": "PTS",
 "mc_rank_col_matches": "M",
 "tg_sc_total": "Total",
 "tg_chase_wickets_in_hand_one": "{0} wicket in hand",
 "tg_matches_n_one": "{0} match",
 "tg_push_value_on": "On",
 "tg_push_value_off": "Off",
 "tg_quiz_title": "Daily quiz",
 "tg_quiz_counter": "{0} / {1}",
 "tg_quiz_next": "Next",
 "tg_quiz_kind_venue": "Stadium",
 "tg_quiz_kind_player": "Player",
 "tg_quiz_kind_who_am_i": "Who am I?",
 "tg_quiz_kind_equipment": "Equipment",
 "tg_quiz_kind_history": "History",
 "tg_quiz_your_score": "Your score",
 "tg_quiz_compare_country": "Better than {0}% of players in {1} today",
 "tg_quiz_compare_all": "Better than {0}% of players today",
 "tg_quiz_streak": "Day streak",
 "tg_quiz_expert_plus": "+{0}",
 "tg_quiz_expert_point": "Expert point",
 "tg_quiz_expert_points": "Expert points",
 "tg_quiz_expert_hint": "{0} out of {1} — expert point",
 "tg_quiz_next_in": "Next quiz in {0} h {1} min",
 "tg_quiz_next_ready": "A new quiz is ready",
 "tg_quiz_play": "Play",
 "tg_quiz_unavailable": "The quiz will be back soon",
 "tg_quiz_to_matches": "To matches",
 "tg_compare_teams_title": "Compare teams",
 "tg_compare_teams_change": "Change opponent",
 "tg_compare_teams_no_common_format": "These teams have no format in common",
 "tg_compare_teams_incompatible": "These teams can't be compared: pick a team of the same kind",
 "tg_compare_teams_not_found": "Team not found",
 "tg_compare_teams_few": "Few matches",
 "tg_compare_teams_vs": "vs",
 "tg_compare_teams_numbers": "Results",
 "tg_compare_teams_scores": "Scores",
 "tg_compare_teams_splits": "Win % by situation",
 "tg_compare_teams_position": "Position",
 "tg_compare_teams_rating": "Rating",
 "tg_compare_teams_points": "Points",
 "tg_match_chat_tab": "Chat",
 "tg_match_chat_write": "Write",
 "tg_match_chat_empty": "No messages yet",
 "tg_match_chat_reply": "Reply",
 "tg_match_chat_report": "Report",
 "tg_match_chat_hide_author": "Hide author",
 "tg_match_chat_reported": "Thanks, we will check it",
 "tg_match_chat_new_messages": "New messages",
 "tg_match_chat_reply_to": "Reply to {0}",
 "tg_match_chat_reply_cancel": "Cancel reply",
 "tg_match_chat_you": "You",
 "tg_match_chat_muted_until": "You can write again on {0}",
 "tg_match_chat_wait": "Wait {0} s",
 "tg_match_chat_closed": "Chat for this match is closed",
 "tg_club_members_active": "{0} members · {1} active",
 "tg_club_members_title": "Members this week",
 "tg_club_history_title": "Last 4 weeks",
 "tg_club_not_ranked": "Not in the table",
 "tg_rating_below_title": "Not in prize table yet",
 "tg_rating_active_of": "{0}/{1} active",
 "tg_country_fans_empty": "No fans of this country have points this week",
 "tg_expert_exchange_title": "Or with expert points",
 "tg_expert_exchange_offer": "{0} days — {1} points",
 "tg_expert_exchange_balance": "You have {0}",
 "tg_expert_exchange_need": "{0} more points needed",
 "tg_expert_exchange_need_one": "1 more point needed",
 "tg_expert_exchange_next": "Next exchange from {0}",
 "tg_expert_exchange_cooldown": "The next exchange will open later",
 "tg_expert_exchange_ads": "Watch about {0} more reward ads in the game",
 "tg_expert_exchange_term_cap": "Your Premium is already paid too far ahead",
 "tg_expert_exchange_premium_active": "Not available while your Premium subscription renews",
 "tg_expert_exchange_unavailable": "Exchange is not available right now",
 "tg_expert_exchange_failed": "Couldn’t exchange points. Try again",
 "tg_expert_exchange_confirm": "Exchange {0} points for {1} days of Premium?",
 "tg_expert_exchange_ok": "Exchange",
 "tg_expert_exchange_cancel": "Cancel",
 "tg_expert_exchange_until": "Premium until {0}",
 "tg_expert_exchange_get_premium": "Get Premium",
 "tg_onb_welcome_title": "Cricket News",
 "tg_onb_welcome_subtitle": "Live scores, stats, and news from your favorite teams",
 "tg_onb_welcome_cta": "Quick Setup",
 "tg_onb_policy_title": "Privacy & data",
 "tg_onb_policy_subtitle": "We respect your privacy. Here is how we use data to improve Cricket News",
 "tg_onb_policy_shield_title": "Your data stays protected",
 "tg_onb_policy_shield_body": "We process information according to our Privacy Policy and industry security standards",
 "tg_onb_policy_personal_title": "A more personal experience",
 "tg_onb_policy_personal_body": "Some data helps us tailor scores, recommendations, and ads to your interests",
 "tg_onb_policy_control_title": "You stay in control",
 "tg_onb_policy_control_body": "Review the full policy anytime and manage privacy settings in the app",
 "tg_onb_policy_accept": "Accept and continue",
 "tg_onb_policy_read": "Read Privacy Policy",
 "tg_onb_list_teams": "Choose Your Teams",
 "tg_onb_empty_teams_title": "No Teams Found",
 "tg_onb_empty_teams_text": "We couldn’t find a team matching your search.\nTry another name.",
 "tg_onb_empty_players_title": "No Players Found",
 "tg_onb_empty_players_text": "We couldn’t find a player matching your search.\nTry another name.",
 "tg_onb_empty_leagues_title": "No Leagues Found",
 "tg_onb_empty_leagues_text": "We couldn’t find a league matching your search.\nTry another name.",
 "tg_onb_ntf_allow": "Allow Notifications",
 "tg_onb_ntf_app": "Cricket News",
 "tg_onb_ntf_now": "now",
 "tg_onb_ntf_toss": "🏏 Toss: India won and chose to bat",
 "tg_onb_ntf_wicket": "Wicket! Sharma c Anderson b Bennett — 145/3",
 "tg_onb_ntf_start": "Match Start: IND vs AUS in 15 min",
 "tg_onb_ntf_miss": "Without notifications you’ll miss this",
 "tg_onb_ntf_muted": "Muted",
 "tg_onb_finish": "Finish",
 "tg_onb_pw_title": "Unlock the Full Cricket Experience",
 "tg_onb_pw_subtitle": "Get closer to the game with exclusive insights, real-time updates, and an uninterrupted cricket experience.",
 "tg_onb_pw_unlock": "Unlock Premium",
 "tg_onb_pw_later": "Maybe Later",
 "tg_onb_pw_what": "What you will get",
 "tg_onb_pw_free": "FREE",
 "tg_onb_pw_pro": "PRO",
 "tg_onb_pw_ads": "No ads",
 "tg_onb_pw_compare": "Compare players and teams",
 "tg_onb_pw_records": "Records and rankings",
 "tg_onb_pw_save": "SAVE {0}%",
 "tg_onb_pw_renews": "Renews monthly",
 "tg_onb_pw_once": "One-time payment",
 "tg_onb_continue": "Continue"
}
